import { UserFilter } from '../models'
import { CreateUserDto, UpdateUserDto } from '../models/user/dto'
import axiosClient from './axiosClient'

const PATH = '/users'

export const userApi = {
  getUsers: (filter?: UserFilter) =>
    axiosClient.get(PATH, {
      params: { ...filter },
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  getUserTypes: () =>
    axiosClient.get('user-types', {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  createUser: (user: CreateUserDto) =>
    axiosClient.post(PATH, user, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  updateUser: (id: number, user: UpdateUserDto) =>
    axiosClient.put(`${PATH}/${id}`, user, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),

  resetPassword: (id: number, password: string) =>
    axiosClient.put(
      `${PATH}/${id}`,
      { password },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      }
    ),

  deleteUser: (id: number) =>
    axiosClient.delete(`${PATH}/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }),
}
